<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">{{routeName}}</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/parent-corporation" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="createparentCorp">
                 <div class="row justify-content-md-center">
              <div class="col-12">
                <div class="row">
                  <div class="col-12" v-if="corps.length">
                    <multiselect
                                 v-model="parentCorp.csvCorporationIds"
                                 placeholder="Associate child Corporations"
                                 :multiple="true"
                                 :taggable="true"
                                 :options="corps.map(type => type.corporationId)"
                                 :custom-label="opt => corps.find(x => x.corporationId == opt).name"
                                  required>
                                >
                    </multiselect>
<!--                    <fg-select-->
<!--                      v-model="parentCorp.corporationId"-->
<!--                      label="Select Corporation"-->
<!--                      :list="corps"-->
<!--                      selectedKey="corporationId"-->
<!--                      v-validate="rules.corporationId"-->
<!--                      data-vv-name="Corproration"-->
<!--                      cus-name="Corporation"-->
<!--                      :has-errors="errors"-->
<!--                      :is-fields="fields">-->
<!--                    </fg-select>-->
                  </div>
                  <div class="col-md-12">
                    <fg-input type="text"
                              v-model="parentCorp.name"
                              label="Parent Corporation Title"
                              placeholder="Enter Title"
                              v-validate="rules.name"
                              data-vv-name="name"
                              cus-name="name"
                              :has-errors="errors"
                              :is-fields="fields">
                    </fg-input>
                  </div>
                  <div class="col-md-12">
                    <fg-input type="text"
                              v-model="parentCorp.description"
                              label="Description"
                              placeholder="Enter Description"
                              v-validate="rules.description"
                              data-vv-name="Description"
                              cus-name="Description"
                              :has-errors="errors"
                              :is-fields="fields">
                    </fg-input>
                  </div>
                  <div class="col-md-3" v-if="status.length">
                    <fg-select
                      v-model="parentCorp.active"
                      label="Active"
                      v-validate="rules.active"
                      data-vv-name="active"
                      cus-name="active"
                      :has-errors="errors"
                      :is-fields="fields"
                      :list="status"
                      selectedKey="id"
                    >
                    </fg-select>
                  </div>
                </div>
              </div>
              <div class="col-6 text-center">
                <button type="submit" :disabled="errors.any() || (!parentCorp.csvCorporationIds || parentCorp.csvCorporationIds.length === 0)" class="btn btn-primary btn-fill btn-block">
                  Create Parent Corporation
                </button>
              </div>
            </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'CreateParentCorporation',
        data () {
        return {
            type: '',
            selectedCorpId: null,
            corporations: [],
            corporationsList: [],
            packages: [],
            corps: [],
            parentCorp: {
              name: '',
              contactFirstName: '',
              contactLastName: '',
              contactEmail: '',
              contactPhone: '',
              contactAddress: '',
              contactCity: '',
              contactState: '',
              contactZip: '',
              description: '',
              csvCorporationIds: null
            },
          status: [{name:'Select Status'}, {id:1, name:'Active'}, {id:0, name:'Inactive'}],
            rules: {
              name : {required: true},
              description: {required: true},
              csvCorporationIds: {required: true}
            }
        }
    },
    methods: {
      customLabel (option) {
        return option.name.toString().toUpperCase()
      },
      fetchCorporations () {
        this.$store.dispatch('FETCH_CORPORATIONS')
          .then((res) => {
            this.corps = res;
            console.log("this.corporations : ", this.corps);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
      createparentCorp () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            console.log("this.parentCorp : ", this.parentCorp);

            let createparentCorp = () => {
              this.$store.dispatch('ADD_PARENT_CORP', this.parentCorp)
                .then((res) => {
                  console.log("ADD_parentCorp res : ", res);
                  if (res) this.showPopup('Success!', 'Parent Corporation is successfully created', 'success', () => this.$router.push('/admin/parent-corporations'))
                  else this.showPopup('Error!', 'Unable to process.', 'error')
                })
                .catch(err => {
                  this.showPopup('Error!', 'parentCorp already exitst.', 'error')
                  console.log("ADD_parentCorp API error : ", err);
                })
            };
            createparentCorp();
          }

        })
      },
      showPopup(title, msg, popupType, cb){
        this.$swal(title, msg, popupType
        ).then(res => {
          cb && cb();
          return res
        })
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      }
    },
    computed:{
        routeName () {
            const {name} = this.$route;
            return this.capitalizeFirstLetter(name);
        }
    },
    created() {
      this.fetchCorporations();
    }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/ParentCorps/CreateParentCorp.vue